// * ---- LIVE SERVER ---- * //
// export const liveServer = process.env.REACT_APP_LIVE_SERVER || "http://192.168.100.11";
// export const liveServerPort = process.env.REACT_APP_LIVE_SERVER_PORT || 8001;
// export const liveServerFlvPort = process.env.REACT_APP_LIVE_SERVER_FLV_PORT || 8000;
// export const streamingServerUrl = process.env.REACT_APP_STREAMING_SERVER_URL || "rtmp://192.168.100.11:1935/live";
export const googleMapApiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY || "";

